import React from "react";

function CaseCardOutline() {
    return (
        <div className="tde-case-card-outline tde-border">
            CARDS
        </div>
    );
}

export default CaseCardOutline;
